import {
  TextInput,
  TextInputProps,
} from "@jugl-web/ui-components/cross-platform/forms/TextInput";
import { useIntervalRerender } from "@jugl-web/utils/hooks/useIntervalRerender";
import { format } from "date-fns";
import { FC } from "react";

interface CurrentTimeInputProps {
  label: string;
  classNames?: {
    wrapperClassName?: string;
    labelClassName?: string;
    inputClassName?: string;
  };
  size: TextInputProps["size"];
}

export const CurrentTimeInput: FC<CurrentTimeInputProps> = ({
  label,
  classNames,
  size,
}) => {
  useIntervalRerender(500);

  return (
    <TextInput
      size={size}
      label={label}
      classNames={classNames}
      value={format(new Date(), "hh:mm a")}
      isDisabled
      readOnly
    />
  );
};
